<template>
  <div
    class="upload-container"
    :class="{ active: isActive }"
    @dragover.prevent="onDragOver"
    @dragleave.prevent="onDragLeave"
    @drop.prevent="onDrop($event)">
    <div v-if="withLogo" class="mb-4">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="97"
        height="86"
        viewBox="0 0 97 86"
        fill="none">
        <mask
          id="path-1-outside-1_4686_44392"
          maskUnits="userSpaceOnUse"
          x="-0.0917969"
          y="0.393066"
          width="97"
          height="86"
          fill="black">
          <rect fill="white" x="-0.0917969" y="0.393066" width="97" height="86" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M73.1571 58.7335C72.9227 44.8224 61.7395 33.5793 48.0265 33.5793C34.3133 33.5793 23.1299 44.823 22.896 58.7343H17.9994C9.68444 58.7343 2.91902 51.8435 2.91902 43.3745C2.91902 34.9055 9.68444 28.0147 17.9994 28.0147H18.4023C19.0364 28.0147 19.5139 27.4223 19.3876 26.7867C18.2406 21.0318 19.6719 15.127 23.3149 10.5879C31.7857 0.0336938 47.9637 1.41377 54.6242 13.1159C52.3568 15.0328 50.6516 17.6116 49.7919 20.5541C49.6332 21.0961 49.9363 21.6658 50.4684 21.8275L50.4685 21.8274C51.0028 21.9898 51.5615 21.6789 51.7187 21.1376C53.3289 15.627 58.3461 11.7527 63.9788 11.6328C64.0679 11.631 64.1572 11.6301 64.2466 11.6301C71.4528 11.6301 77.3163 17.6023 77.3163 24.942C77.3163 25.5659 77.2711 26.2066 77.1813 26.8444C77.1397 27.1384 77.2259 27.4361 77.4169 27.6607C77.6079 27.8852 77.8851 28.0139 78.1766 28.0139H78.3217C86.6367 28.0139 93.4021 34.9047 93.4021 43.3737C93.4021 51.8427 86.6367 58.7335 78.3217 58.7335H73.1571ZM73.1122 60.7815H78.3217L78.3212 60.7815C87.7451 60.7815 95.4125 52.9729 95.4125 43.3737C95.4125 34.1059 88.2658 26.5072 79.2901 25.9945C79.8943 17.1678 73.0021 9.61045 64.2937 9.58305C64.2785 9.58235 64.2631 9.58199 64.2477 9.58199C63.4783 9.58199 62.7227 9.64059 61.9849 9.75359C60.5172 9.97747 59.0993 10.4198 57.7648 11.0694C57.246 11.3214 56.7437 11.6027 56.2599 11.9111C48.7589 -0.951804 31.0163 -2.24441 21.758 9.29181C17.9865 13.9918 16.3592 20.0143 17.2102 25.9849C8.15105 26.4062 0.908203 34.0452 0.908203 43.3744C0.908203 52.9729 8.57553 60.7823 17.9994 60.7823H22.9409C23.756 74.1544 34.6961 84.7792 48.0265 84.7792C61.3574 84.7792 72.2975 74.1538 73.1122 60.7815ZM24.926 60.2262C25.4656 72.7286 35.6211 82.7307 48.0265 82.7307C60.7764 82.7307 71.1497 72.1653 71.1497 59.1793C71.1497 46.193 60.7764 35.6278 48.0265 35.6278C35.2765 35.6278 24.9034 46.1932 24.9034 59.1793L24.9035 59.2484C24.9884 59.3985 25.0369 59.5726 25.0369 59.7583C25.0369 59.9268 24.9969 60.0859 24.926 60.2262ZM48.4857 70.2349C48.0793 70.2349 47.7496 69.8992 47.7496 69.4853V51.8036L43.1169 56.5222C42.8298 56.8151 42.3635 56.8151 42.0759 56.5222C41.7883 56.2293 41.7883 55.7549 42.0759 55.462L47.962 49.4668C48.0954 49.3292 48.2808 49.2439 48.4857 49.2439C48.7055 49.2439 48.9028 49.3421 49.0377 49.4978L54.8934 55.462C55.181 55.7549 55.181 56.2293 54.8934 56.5222C54.7499 56.6689 54.5611 56.7418 54.3729 56.7418C54.1847 56.7417 53.996 56.6684 53.8525 56.5222L49.2217 51.8056V69.4853C49.2217 69.8997 48.8921 70.2349 48.4857 70.2349Z" />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M73.1571 58.7335C72.9227 44.8224 61.7395 33.5793 48.0265 33.5793C34.3133 33.5793 23.1299 44.823 22.896 58.7343H17.9994C9.68444 58.7343 2.91902 51.8435 2.91902 43.3745C2.91902 34.9055 9.68444 28.0147 17.9994 28.0147H18.4023C19.0364 28.0147 19.5139 27.4223 19.3876 26.7867C18.2406 21.0318 19.6719 15.127 23.3149 10.5879C31.7857 0.0336938 47.9637 1.41377 54.6242 13.1159C52.3568 15.0328 50.6516 17.6116 49.7919 20.5541C49.6332 21.0961 49.9363 21.6658 50.4684 21.8275L50.4685 21.8274C51.0028 21.9898 51.5615 21.6789 51.7187 21.1376C53.3289 15.627 58.3461 11.7527 63.9788 11.6328C64.0679 11.631 64.1572 11.6301 64.2466 11.6301C71.4528 11.6301 77.3163 17.6023 77.3163 24.942C77.3163 25.5659 77.2711 26.2066 77.1813 26.8444C77.1397 27.1384 77.2259 27.4361 77.4169 27.6607C77.6079 27.8852 77.8851 28.0139 78.1766 28.0139H78.3217C86.6367 28.0139 93.4021 34.9047 93.4021 43.3737C93.4021 51.8427 86.6367 58.7335 78.3217 58.7335H73.1571ZM73.1122 60.7815H78.3217L78.3212 60.7815C87.7451 60.7815 95.4125 52.9729 95.4125 43.3737C95.4125 34.1059 88.2658 26.5072 79.2901 25.9945C79.8943 17.1678 73.0021 9.61045 64.2937 9.58305C64.2785 9.58235 64.2631 9.58199 64.2477 9.58199C63.4783 9.58199 62.7227 9.64059 61.9849 9.75359C60.5172 9.97747 59.0993 10.4198 57.7648 11.0694C57.246 11.3214 56.7437 11.6027 56.2599 11.9111C48.7589 -0.951804 31.0163 -2.24441 21.758 9.29181C17.9865 13.9918 16.3592 20.0143 17.2102 25.9849C8.15105 26.4062 0.908203 34.0452 0.908203 43.3744C0.908203 52.9729 8.57553 60.7823 17.9994 60.7823H22.9409C23.756 74.1544 34.6961 84.7792 48.0265 84.7792C61.3574 84.7792 72.2975 74.1538 73.1122 60.7815ZM24.926 60.2262C25.4656 72.7286 35.6211 82.7307 48.0265 82.7307C60.7764 82.7307 71.1497 72.1653 71.1497 59.1793C71.1497 46.193 60.7764 35.6278 48.0265 35.6278C35.2765 35.6278 24.9034 46.1932 24.9034 59.1793L24.9035 59.2484C24.9884 59.3985 25.0369 59.5726 25.0369 59.7583C25.0369 59.9268 24.9969 60.0859 24.926 60.2262ZM48.4857 70.2349C48.0793 70.2349 47.7496 69.8992 47.7496 69.4853V51.8036L43.1169 56.5222C42.8298 56.8151 42.3635 56.8151 42.0759 56.5222C41.7883 56.2293 41.7883 55.7549 42.0759 55.462L47.962 49.4668C48.0954 49.3292 48.2808 49.2439 48.4857 49.2439C48.7055 49.2439 48.9028 49.3421 49.0377 49.4978L54.8934 55.462C55.181 55.7549 55.181 56.2293 54.8934 56.5222C54.7499 56.6689 54.5611 56.7418 54.3729 56.7418C54.1847 56.7417 53.996 56.6684 53.8525 56.5222L49.2217 51.8056V69.4853C49.2217 69.8997 48.8921 70.2349 48.4857 70.2349Z"
          fill="#1D385D" />
        <path
          d="M73.1571 58.7335L72.4623 58.7452L72.4738 59.4284H73.1571V58.7335ZM22.896 58.7343V59.4291H23.5793L23.5907 58.7459L22.896 58.7343ZM19.3876 26.7867L20.0691 26.6512L20.069 26.6509L19.3876 26.7867ZM23.3149 10.5879L22.773 10.1529L22.7729 10.1529L23.3149 10.5879ZM54.6242 13.1159L55.0728 13.6465L55.5136 13.2738L55.2281 12.7722L54.6242 13.1159ZM49.7919 20.5541L50.4588 20.7494L50.4589 20.749L49.7919 20.5541ZM50.4684 21.8275L50.2664 22.4924L50.6993 22.6239L50.9947 22.2812L50.4684 21.8275ZM50.4685 21.8274L50.6706 21.1625L50.2376 21.0309L49.9422 21.3737L50.4685 21.8274ZM51.7187 21.1376L51.0517 20.9428L51.0514 20.9438L51.7187 21.1376ZM63.9788 11.6328L63.9646 10.9381L63.964 10.9381L63.9788 11.6328ZM77.1813 26.8444L77.8693 26.9419L77.8694 26.9413L77.1813 26.8444ZM78.3217 60.7815L78.3794 61.4739L78.3217 60.0866V60.7815ZM73.1122 60.7815V60.0866H72.4584L72.4186 60.7392L73.1122 60.7815ZM78.3212 60.7815L78.2635 60.089L78.3212 61.4764V60.7815ZM79.2901 25.9945L78.5968 25.947L78.5488 26.6482L79.2504 26.6882L79.2901 25.9945ZM64.2937 9.58305L64.2618 10.2772L64.2767 10.2779L64.2916 10.2779L64.2937 9.58305ZM61.9849 9.75359L62.0897 10.4405L62.0901 10.4405L61.9849 9.75359ZM57.7648 11.0694L58.0684 11.6945L58.0689 11.6942L57.7648 11.0694ZM56.2599 11.9111L55.6596 12.2612L56.0238 12.8857L56.6334 12.4971L56.2599 11.9111ZM21.758 9.29181L21.2161 8.85688L21.216 8.85691L21.758 9.29181ZM17.2102 25.9849L17.2425 26.6791L18.006 26.6436L17.8981 25.8869L17.2102 25.9849ZM22.9409 60.7823L23.6345 60.74L23.5948 60.0874H22.9409V60.7823ZM24.926 60.2262L24.3058 59.9127L24.2239 60.0747L24.2317 60.2561L24.926 60.2262ZM24.9034 59.1793H24.2085L24.2085 59.1802L24.9034 59.1793ZM24.9035 59.2484L24.2086 59.2493L24.2089 59.4316L24.2985 59.5902L24.9035 59.2484ZM47.7496 51.8036H48.4445V50.104L47.2538 51.3168L47.7496 51.8036ZM43.1169 56.5222L42.621 56.0354L42.6206 56.0358L43.1169 56.5222ZM42.0759 56.5222L42.5718 56.0354L42.0759 56.5222ZM42.0759 55.462L42.5718 55.9488L42.0759 55.462ZM47.962 49.4668L48.4578 49.9537L48.4609 49.9506L47.962 49.4668ZM49.0377 49.4978L48.5125 49.9528L48.5267 49.9692L48.5419 49.9846L49.0377 49.4978ZM54.8934 55.462L55.3892 54.9751L54.8934 55.462ZM54.8934 56.5222L54.3975 56.0354L54.3967 56.0363L54.8934 56.5222ZM54.3729 56.7418L54.3729 57.4366H54.3729V56.7418ZM53.8525 56.5222L54.3483 56.0354L53.8525 56.5222ZM49.2217 51.8056L49.7175 51.3188L48.5268 50.106V51.8056H49.2217ZM48.0265 34.2742C61.3479 34.2742 72.2341 45.2007 72.4623 58.7452L73.8519 58.7218C73.6113 44.444 62.1311 32.8844 48.0265 32.8844V34.2742ZM23.5907 58.7459C23.8186 45.2013 34.7049 34.2742 48.0265 34.2742V32.8844C33.9217 32.8844 22.4413 44.4446 22.2012 58.7226L23.5907 58.7459ZM17.9994 59.4291H22.896V58.0394H17.9994V59.4291ZM2.22414 43.3745C2.22414 52.2152 9.2887 59.4291 17.9994 59.4291V58.0394C10.0802 58.0394 3.61391 51.4718 3.61391 43.3745H2.22414ZM17.9994 27.3198C9.2887 27.3198 2.22414 34.5338 2.22414 43.3745H3.61391C3.61391 35.2772 10.0802 28.7096 17.9994 28.7096V27.3198ZM18.4023 27.3198H17.9994V28.7096H18.4023V27.3198ZM18.706 26.9222C18.7499 27.1429 18.5831 27.3198 18.4023 27.3198V28.7096C19.4897 28.7096 20.278 27.7016 20.0691 26.6512L18.706 26.9222ZM22.7729 10.1529C19.0002 14.8539 17.5193 20.968 18.7061 26.9225L20.069 26.6509C18.9618 21.0955 20.3437 15.4002 23.8568 11.0228L22.7729 10.1529ZM55.2281 12.7722C48.3271 0.647522 31.5536 -0.787273 22.773 10.1529L23.8568 11.0228C32.0178 0.85466 47.6002 2.18003 54.0202 13.4596L55.2281 12.7722ZM50.4589 20.749C51.2799 17.9389 52.9084 15.4764 55.0728 13.6465L54.1755 12.5852C51.8052 14.5892 50.0233 17.2843 49.1249 20.3592L50.4589 20.749ZM50.6704 21.1626C50.5116 21.1144 50.4046 20.9345 50.4588 20.7494L49.125 20.3588C48.8618 21.2577 49.361 22.2173 50.2664 22.4924L50.6704 21.1626ZM49.9422 21.3737L49.9421 21.3738L50.9947 22.2812L50.9948 22.2811L49.9422 21.3737ZM51.0514 20.9438C50.999 21.1244 50.8235 21.209 50.6706 21.1625L50.2664 22.4922C51.1821 22.7705 52.124 22.2334 52.386 21.3315L51.0514 20.9438ZM63.964 10.9381C58.0224 11.0645 52.7454 15.1466 51.0517 20.9428L52.3857 21.3325C53.9125 16.1074 58.6698 12.4408 63.9935 12.3276L63.964 10.9381ZM64.2466 10.9352C64.1525 10.9352 64.0585 10.9362 63.9646 10.9381L63.9929 12.3276C64.0773 12.3259 64.1619 12.325 64.2466 12.325V10.9352ZM78.0112 24.942C78.0112 17.2306 71.8486 10.9352 64.2466 10.9352V12.325C71.0571 12.325 76.6215 17.974 76.6215 24.942H78.0112ZM77.8694 26.9413C77.9636 26.2722 78.0112 25.5991 78.0112 24.942H76.6215C76.6215 25.5327 76.5786 26.1411 76.4932 26.7476L77.8694 26.9413ZM77.9462 27.2104C77.8846 27.1381 77.8554 27.04 77.8693 26.9419L76.4933 26.7469C76.4239 27.2369 76.5671 27.7342 76.8876 28.1109L77.9462 27.2104ZM78.1766 27.3191C78.091 27.3191 78.0066 27.2814 77.9462 27.2104L76.8876 28.1109C77.2092 28.489 77.6791 28.7088 78.1766 28.7088V27.3191ZM78.3217 27.3191H78.1766V28.7088H78.3217V27.3191ZM94.097 43.3737C94.097 34.533 87.0324 27.3191 78.3217 27.3191V28.7088C86.2409 28.7088 92.7072 35.2764 92.7072 43.3737H94.097ZM78.3217 59.4284C87.0324 59.4284 94.097 52.2144 94.097 43.3737H92.7072C92.7072 51.471 86.2409 58.0386 78.3217 58.0386V59.4284ZM73.1571 59.4284H78.3217V58.0386H73.1571V59.4284ZM78.3217 60.0866H73.1122V61.4763H78.3217V60.0866ZM78.3789 61.474L78.3794 61.4739L78.264 60.089L78.2635 60.089L78.3789 61.474ZM94.7176 43.3737C94.7176 52.6012 87.3494 60.0866 78.3212 60.0866V61.4764C88.1408 61.4764 96.1073 53.3446 96.1073 43.3737H94.7176ZM79.2504 26.6882C87.8496 27.1795 94.7176 34.4655 94.7176 43.3737H96.1073C96.1073 33.7463 88.6819 25.835 79.3297 25.3007L79.2504 26.6882ZM64.2916 10.2779C72.5854 10.304 79.1745 17.508 78.5968 25.947L79.9833 26.0419C80.6141 16.8276 73.4188 8.91688 64.2959 8.88817L64.2916 10.2779ZM64.2477 10.2769C64.2525 10.2769 64.2572 10.277 64.2618 10.2772L64.3257 8.8889C64.2998 8.88771 64.2737 8.88711 64.2477 8.88711V10.2769ZM62.0901 10.4405C62.7932 10.3328 63.5136 10.2769 64.2477 10.2769V8.88711C63.4429 8.88711 62.6522 8.9484 61.8797 9.06672L62.0901 10.4405ZM58.0689 11.6942C59.3405 11.0752 60.6913 10.6538 62.0897 10.4405L61.8801 9.06665C60.3432 9.30109 58.858 9.76438 57.4606 10.4446L58.0689 11.6942ZM56.6334 12.4971C57.0949 12.2029 57.5738 11.9347 58.0684 11.6945L57.4611 10.4444C56.9181 10.7082 56.3925 11.0025 55.8864 11.3252L56.6334 12.4971ZM22.2999 9.72674C31.2525 -1.42858 48.4037 -0.181444 55.6596 12.2612L56.8602 11.5611C49.114 -1.72216 30.78 -3.06024 21.2161 8.85688L22.2999 9.72674ZM17.8981 25.8869C17.074 20.1045 18.6499 14.2754 22.3 9.72671L21.216 8.85691C17.3231 13.7082 15.6445 19.9241 16.5223 26.083L17.8981 25.8869ZM1.60309 43.3744C1.60309 34.407 8.56345 27.0827 17.2425 26.6791L17.1779 25.2908C7.73864 25.7298 0.213319 33.6834 0.213319 43.3744H1.60309ZM17.9994 60.0874C8.97127 60.0874 1.60309 52.6012 1.60309 43.3744H0.213319C0.213319 53.3446 8.17979 61.4771 17.9994 61.4771V60.0874ZM22.9409 60.0874H17.9994V61.4771H22.9409V60.0874ZM48.0265 84.0843C35.0768 84.0843 24.428 73.7589 23.6345 60.74L22.2473 60.8245C23.0839 74.5498 34.3154 85.4741 48.0265 85.4741V84.0843ZM72.4186 60.7392C71.6255 73.7584 60.9767 84.0843 48.0265 84.0843V85.4741C61.7382 85.4741 72.9696 74.5492 73.8058 60.8237L72.4186 60.7392ZM48.0265 82.0359C36.0062 82.0359 26.1443 72.34 25.6202 60.1962L24.2317 60.2561C24.7868 73.1172 35.236 83.4256 48.0265 83.4256V82.0359ZM70.4548 59.1793C70.4548 71.7936 60.3807 82.0359 48.0265 82.0359V83.4256C61.1722 83.4256 71.8446 72.537 71.8446 59.1793H70.4548ZM48.0265 36.3227C60.3807 36.3227 70.4548 46.5647 70.4548 59.1793H71.8446C71.8446 45.8213 61.1722 34.9329 48.0265 34.9329V36.3227ZM25.5983 59.1793C25.5983 46.5649 35.6722 36.3227 48.0265 36.3227V34.9329C34.8807 34.9329 24.2085 45.8215 24.2085 59.1793H25.5983ZM25.5984 59.2474L25.5983 59.1783L24.2085 59.1802L24.2086 59.2493L25.5984 59.2474ZM25.7318 59.7583C25.7318 59.4502 25.651 59.1586 25.5085 58.9065L24.2985 59.5902C24.3258 59.6384 24.342 59.6951 24.342 59.7583H25.7318ZM25.5461 60.5397C25.6652 60.3041 25.7318 60.0379 25.7318 59.7583H24.342C24.342 59.8158 24.3285 59.8677 24.3058 59.9127L25.5461 60.5397ZM47.0547 69.4853C47.0547 70.2709 47.6835 70.9298 48.4857 70.9298V69.54C48.4785 69.54 48.4705 69.538 48.4611 69.5285C48.4515 69.5187 48.4445 69.5046 48.4445 69.4853H47.0547ZM47.0547 51.8036V69.4853H48.4445V51.8036H47.0547ZM47.2538 51.3168L42.621 56.0354L43.6127 57.009L48.2455 52.2905L47.2538 51.3168ZM42.6206 56.0358C42.6152 56.0413 42.611 56.0436 42.6081 56.0448C42.6048 56.0462 42.6009 56.047 42.5966 56.047C42.5923 56.047 42.5883 56.0462 42.5848 56.0447C42.5817 56.0434 42.5773 56.041 42.5718 56.0354L41.5801 57.009C42.1398 57.5791 43.0534 57.5797 43.6132 57.0086L42.6206 56.0358ZM42.5718 56.0354C42.5618 56.0252 42.5551 56.011 42.5551 55.9921C42.5551 55.9732 42.5618 55.9589 42.5718 55.9488L41.5801 54.9751C41.0271 55.5383 41.0271 56.4458 41.5801 57.009L42.5718 56.0354ZM42.5718 55.9488L48.4578 49.9537L47.4661 48.98L41.5801 54.9751L42.5718 55.9488ZM48.4857 48.549C48.0831 48.549 47.7206 48.7176 47.4631 48.9831L48.4609 49.9506C48.4657 49.9455 48.4705 49.9426 48.4741 49.941C48.4772 49.9397 48.4806 49.9388 48.4857 49.9388V48.549ZM49.5629 49.0428C49.3034 48.7432 48.9179 48.549 48.4857 48.549V49.9388C48.491 49.9388 48.4946 49.9398 48.498 49.9414C48.5021 49.9433 48.5074 49.9469 48.5125 49.9528L49.5629 49.0428ZM48.5419 49.9846L54.3976 55.9488L55.3892 54.9751L49.5336 49.011L48.5419 49.9846ZM54.3976 55.9488C54.4075 55.9589 54.4142 55.9732 54.4142 55.9921C54.4142 56.011 54.4075 56.0252 54.3976 56.0354L55.3892 57.009C55.9422 56.4458 55.9422 55.5383 55.3892 54.9751L54.3976 55.9488ZM54.3967 56.0363C54.3918 56.0413 54.388 56.0434 54.3851 56.0446C54.3817 56.046 54.3775 56.0469 54.3729 56.0469V57.4366C54.7408 57.4366 55.1109 57.2936 55.3901 57.0081L54.3967 56.0363ZM54.373 56.0469C54.369 56.0469 54.365 56.0461 54.3612 56.0445C54.3579 56.0432 54.3536 56.0407 54.3483 56.0354L53.3566 57.009C53.6347 57.2923 54.0039 57.4366 54.3729 57.4366L54.373 56.0469ZM54.3483 56.0354L49.7175 51.3188L48.7259 52.2925L53.3566 57.009L54.3483 56.0354ZM49.9166 69.4853V51.8056H48.5268V69.4853H49.9166ZM48.4857 70.9298C49.2875 70.9298 49.9166 70.2717 49.9166 69.4853H48.5268C48.5268 69.505 48.5197 69.519 48.5104 69.5286C48.5012 69.5379 48.4932 69.54 48.4857 69.54V70.9298Z"
          fill="#1D395E"
          mask="url(#path-1-outside-1_4686_44392)" />
      </svg>
    </div>
    <div class="header">
      {{ $t('dashboard.drag-and-drop-or') }}
      <span
        class="flex items-center"
        @click.prevent.stop="openUploadPannel">{{ $t('dashboard.select-a-file') }}</span>
    </div>
    <p>{{ $t('dashboard.supported-files') }} : {{ supportedFormatsList }}</p>
    <slot></slot>
    <input ref="fileInput" @change="handleFileSelect" type="file" hidden :accept="accept" />
    <!-- CropperJS Modal -->
    <bc-modal :active="useCropper && showCropper">
      <div class="cropper-container">
        <img ref="image-crop" :src="imgSrc" />
        <div class="cropper-container__buttons">
          <bc-button color="error" @click="closeCropper">
            {{ $t('generics.cancel') }}
          </bc-button>
          <bc-button @click="validCrop">
            {{ $t('generics.validate') }}
          </bc-button>
        </div>
      </div>
    </bc-modal>
    <!-- CropperJS Modal -->
  </div>
</template>

<script>
import Cropper from 'cropperjs';
import BcModal from '@/ui-kit/components/BcModal';
import BcButton from '@/ui-kit/components/BcButton';

export default {
  name: 'upload-container',
  components: {
    BcModal,
    BcButton,
  },
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    supportedFormats: {
      type: Array,
      default: () => ['pdf', 'png', 'jpg', 'jpeg'],
    },
    accept: {
      type: String,
    },
    useCropper: {
      type: Boolean,
      default: false,
    },
    cropperOptions: {
      type: Object,
      default: () => ({}),
    },
    croppedImageSize: {
      type: Object,
      default: () => ({
        width: 1280,
        height: 720,
      }),
    },
    withLogo: {
      type: Boolean,
      default: false,
    }
  },
  destroyed() {
    if (this.cropper) {
      this.cropper.destroy();
    }
  },
  data() {
    return {
      isActive: false,
      file: undefined,
      imgSrc: '',
      cropper: undefined,
      showCropper: false,
    };
  },
  computed: {
    supportedFormatsList() {
      return this.supportedFormats.join(', ').toUpperCase();
    },
  },
  methods: {
    openUploadPannel() {
      this.$refs.fileInput.click();
    },
    onDrop(e) {
      const files = e.dataTransfer.files;
      if (files.length > 1) {
        return (this.errorMessage = this.$i18n.t(
          'dashboard.you-can-only-upload-one-document-at-a-time'
        ));
      }
      this.isActive = false;
      if (this.checkSupportedFile(files[0])) {
        this.file = files[0];
        if (this.useCropper) {
          this.showCropper = true;
          this.$nextTick(() => {
            this.setCropperImg(files[0]);
          });
        }
        this.$emit('on-select', files[0]);
      }
    },
    onDragOver() {
      this.isActive = true;
    },
    onDragLeave() {
      this.isActive = false;
    },
    handleFileSelect(e) {
      const file = e.target.files[0];
      if (this.checkSupportedFile(file)) {
        this.file = file;
        if (this.useCropper) {
          this.showCropper = true;
          this.$nextTick(() => {
            this.setCropperImg(file);
          });
        }
        this.$emit('on-select', file);
      }
    },
    checkSupportedFile(file) {
      const type = file.type.split('/');
      const fileExtension = type[type.length - 1];
      if (!this.supportedFormats.includes(fileExtension)) {
        this.$toast.show({
          type: 'error',
          message: this.$t('dashboard.incorrect-file-format'),
        });
        return false;
      }
      return true;
    },
    setCropper() {
      const image = this.$refs['image-crop'];
      this.cropper = new Cropper(image, this.cropperOptions);
    },
    setCropperImg(file) {
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = event => {
          this.imgSrc = event.target.result;
          this.$nextTick(() => {
            this.setCropper();
          });
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    closeCropper() {
      this.$refs['fileInput'].value = '';
      this.showCropper = false;
      this.imgSrc = '';
      this.file = undefined;
    },
    validCrop() {
      this.cropper
        .getCroppedCanvas(this.croppedImageSize)
        .toBlob(blob => {
          this.$emit('on-cropped', new File([blob], this.file.name));
          this.closeCropper();
        }, 'image/png');
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-container {
  width: 360px;
  height: 110px;
  background: $color-neutre-3;
  border: 1px dashed $color-blue-heavy-dark;
  border-radius: 4px;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & .header {
    font-weight: 700;
    font-size: 15px;
    line-height: 24px;
    color: $color-blue-dark-cello;
    margin-bottom: 10px;

    & > span {
      color: $color-primary;
      text-decoration: underline;
      margin-left: 5px;
      &:hover {
        cursor: pointer;
      }
    }
  }

  & p {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: $color-blue-dark-cello;
  }
}

.upload-container.active {
  border: 2px solid $color-blue-dark-cello;
}

.cropper-container {
  display: block;
  background: white;
  padding: 30px;
  border-radius: 5px;

  & > img {
    display: block;
    width: 800px;
    height: 600px;
  }

  &__buttons {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
  }
}
</style>
